import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import Footer from "../components/Footer/Footer";
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import { Container, SubContainer } from './Styles';
import ManagesTabs from '../components/Managements/ManagesTabs';
import { Stack, Typography } from '@mui/material';

export default function Managements() {
  const { changed } = useContext(UserContext);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ padding: `${window.innerWidth < 800 ? '20px 2% 100px 2%' : '20px 5% 100px 5%'}` }}
        >
          <Typography variant='h5'>Gestão de gerencias</Typography>
          <ManagesTabs />
        </Stack>
        <Footer />
      </SubContainer>
    </Container>
  );
}